/** @jsx jsx */
import { css, jsx, keyframes, SerializedStyles } from '@emotion/react';

interface GlowingDotProps {
  color: string;
  size?: number;
  css?: SerializedStyles;
}

const pulse = (color: string) => keyframes`
  0% {
    box-shadow: 0 0 0 0 ${color}80;
  }
  70% {
    box-shadow: 0 0 0 10px ${color}00;
  }
  100% {
    box-shadow: 0 0 0 0 ${color}00;
  }
`;

export const GlowingDot = ({ color, size = 12, ...props }: GlowingDotProps) => {
  return (
    <div
      css={css`
        width: ${size}px;
        height: ${size}px;
        background-color: ${color};
        border-radius: 50%;
        animation: ${pulse(color)} 2s infinite;
        ${props.css}
      `}
    />
  );
};
